/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PCCItemDecisionOutcome = typeof PCCItemDecisionOutcome[keyof typeof PCCItemDecisionOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PCCItemDecisionOutcome = {
  Created: 'Created',
  Reused: 'Reused',
  Skipped: 'Skipped',
} as const;
